/** 복수 선택 필터 칩. 누르면 켜지고 다시 누르면 꺼진다. */
export function FilterChip({
  active,
  onClick,
  children,
}: {
  active: boolean;
  onClick: () => void;
  children: React.ReactNode;
}): React.JSX.Element {
  return (
    <button
      type="button"
      aria-pressed={active}
      onClick={onClick}
      className={`rounded-full border px-2.5 py-1 text-[11px] whitespace-nowrap ${
        active ? 'border-accent bg-accent font-semibold text-white' : 'border-line bg-surface text-muted hover:bg-line-soft'
      }`}
    >
      {children}
    </button>
  );
}

/**
 * 이름 붙은 복수 선택 칩 묶음. `전체`는 고른 것을 모두 비운다 — 아무것도 고르지 않은 상태가 곧 전체다.
 */
export function FilterChipGroup({
  label,
  options,
  picked,
  onChange,
}: {
  label: string;
  options: ReadonlyArray<{ key: string; label: string }>;
  picked: readonly string[];
  onChange: (next: string[]) => void;
}): React.JSX.Element {
  const toggle = (key: string): void =>
    onChange(picked.includes(key) ? picked.filter((value) => value !== key) : [...picked, key]);
  return (
    <div className="flex flex-wrap items-center gap-1.5" role="group" aria-label={label}>
      <span className="mr-1 w-12 shrink-0 text-[11.5px] text-muted">{label}</span>
      <FilterChip active={picked.length === 0} onClick={() => onChange([])}>
        전체
      </FilterChip>
      {options.map((option) => (
        <FilterChip key={option.key} active={picked.includes(option.key)} onClick={() => toggle(option.key)}>
          {option.label}
        </FilterChip>
      ))}
    </div>
  );
}
